import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2 },
  { title: 'Emissor', flex: 1.5 },
  { title: 'Ativo', flex: 1.2 },
  { title: 'Taxa/ind.', flex: 1.3 },
  { title: 'Índice', flex: 1.2 },
  { title: 'Qtde. disp.' },
  { title: 'Qtde. bloq.' },
  { title: 'Qtde. total' },
  { title: 'Vencimento', flex: 1.3 },
  { title: 'Valor bruto', flex: 1.2 },
];

export const tableHeadPlus: TableHeadItemRecurse[] = [
  { title: 'Data da posição', flex: 1.1 },
  { title: 'Data da compra', flex: 1.1 },
  { title: 'Valor compra', flex: 1.1 },
  { title: 'Valor IOF' },
  { title: 'Valor IR' },
  { title: 'Valor líquido', flex: 1.1 },
];

export const getFixedIncomeFilters = (
  dynamicFilters: FilterModalTypes.FilterType[]
): FilterModalTypes.FilterType[] => [
  {
    type: 'date',
    fieldName: 'maturityDate',
    title: 'Vencimento',
    placeholder: 'Selecione a data de vencimento',
  },
  ...dynamicFilters,
  {
    type: 'range',
    fieldName: 'rate',
    labelType: 'percentage',
    title: 'Taxa',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'availableQuantity',
    labelType: 'number',
    title: 'Quantidade disponível',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'blockedQuantity',
    labelType: 'number',
    title: 'Quantidade bloqueada',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'totalQuantity',
    labelType: 'number',
    title: 'Quantidade total',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'grossValue',
    labelType: 'money',
    title: 'Valor bruto',
    min: 0,
    max: 1000000000,
  },
];
